<template>
  <div class="management-content">
    <div class="title-box">
      <div class="page-title">{{ $t("Header_Attachments") }}</div>
      <div class="right-box">
        <!-- 필터 -->
        <a-popover class="search-filter" placement="bottomRight" trigger="click" v-model:visible="filterState.visible">
          <template #content>
            <div>
              <div class="filter-content">
                <div v-for="item in filterItems" :key="item.key" class="filter-item">
                  <div class="filter-title">{{ $t(item.label) }}</div>
                  <a-checkbox-group v-model:value="filterState[item.model]" :options="item.options"
                    class="check-group" />
                </div>
              </div>
              <hr />
              <div class="filter-button-box">
                <div>
                  <a-button class="filter-button reset" size="small" @click="onFilterReset">{{ $t('Common_FilterReset')
                  }}</a-button>
                </div>
                <div>
                  <a-button class="filter-button confirm" size="small" @click="onFilterConfirm">{{ $t('CH_password1')
                  }}</a-button>
                  <a-button class="filter-button cancel" size="small" @click="onFilterCancel">{{ $t('Common_Cancel')
                  }}</a-button>
                </div>
              </div>
            </div>
          </template>
          <a-button>
            {{ $t('Common_Filter') }}
            <div>
              <span v-if="filterCount" class="filter-count">{{ filterCount }}</span>
              <img v-else src="/img/common/down-arrow.png" />
            </div>
          </a-button>
        </a-popover>
        <!-- 검색 -->
        <a-input-search class="search-input" v-model:value="searchText" :placeholder="$t('Common_Search')"
          @search="onSearch" />
        <div class="page-buttons">
          <a-button class="menu-button" :class="{ disable: btnDisable }"
            @click="() => toggleModal('downloadVisible')">{{
              $t("Common_Download") }}</a-button>
          <AttachFileDownloadModal v-if="downloadVisible" :visible="downloadVisible"
            :toggleModal="() => toggleModal('downloadVisible')" />

          <a-button class="menu-button" @click="() => toggleModal('uploadVisible')">{{ $t("Common_Enroll") }}</a-button>
          <AttachFileUploadEditModal v-if="uploadVisible" mode="add" :visible="uploadVisible"
            :toggleModal="() => toggleModal('uploadVisible')" />
        </div>
      </div>
    </div>
    <CommonTable :loading="loading" :data="tableData" :columns="columns" :fetchData="getAttachFile" :useSelection="true"
      :pagination="pagination" :handleTableChange="handleTableChange" :handleSelect="handleSelect" target="attachInfoNo"
      settingType="attachFile" />
  </div>
</template>

<script>
import {
  onMounted, onUnmounted, toRefs, reactive, watch, computed, ref
} from "vue";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";
import axios from "axios";

import AttachFileDownloadModal from "@/components/sideComponents/AttachFileDownloadModal";
import AttachFileUploadEditModal from "@/components/sideComponents/AttachFileUploadEditModal";
import CommonTable from "@/components/commonComponents/CommonTable";
import { useI18n } from "vue-i18n";

export default {
  name: "AttachFile",
  components: {
    AttachFileDownloadModal,
    AttachFileUploadEditModal,
    CommonTable,
  },
  setup() {
    const store = useStore();
    const attachFileState = computed(() => store.getters["attachFile/STATE"]);
    const { t } = useI18n();

    const state = reactive({
      tableData: [],
      loading: false,
      downloadVisible: false,
      uploadVisible: false,
      searchText: '',
      pagination: {},
      pagesize: 12,
      currentPage: 1,
    });

    const btnDisable = computed(
      () => attachFileState.value.selectedNoArray.length < 1
    );

    const columns = [
      {
        align: "center",
        width: 30,
        slots: { title: "checkboxAll", customRender: "checkbox" },
      },
      {
        align: "center",
        width: 30,
        slots: { title: "settingTitle", customRender: "settingIcon" },
      },
      {
        title: "No",
        dataIndex: "attachInfoNo",
        align: "center",
        width: 50,
      },
      {
        title: t("Attach_File1"),
        dataIndex: "attachCategory",
        align: "center",
        width: 60,
        slots: { customRender: "attachCategory" },
      },
      {
        title: t("Attach_File2"),
        dataIndex: "attachExamType",
        align: "center",
        width: 60,
        slots: { customRender: "attachExamType" },
      },
      {
        title: t("Attach_Upload29"),
        dataIndex: "fileIcon",
        align: "center",
        width: 40,
        slots: { customRender: "fileIcon" },
      },
      {
        title: t("Attach_File3"),
        align: "center",
        width: 40,
        slots: { customRender: "fileExt" },
      },
      {
        title: t("Common_Title"),
        dataIndex: "subject",
        align: "center",
        width: 150,
        ellipsis: true,
      },
      {
        title: t("Attach_Upload5"),
        dataIndex: "attachFunction",
        align: "center",
        width: 100,
        slots: { customRender: "attachFunction" },
      },
      {
        title: t("Attach_Upload7"),
        dataIndex: "attachRestrict",
        align: "center",
        width: 100,
        slots: { customRender: "attachRestrict" },
      },
      {
        title: t("Common_Public"),
        dataIndex: "isPublic",
        align: "center",
        width: 50,
        slots: { customRender: "ox" },
      },
      {
        title: t("Common_RegDate"),
        dataIndex: "regEpoch",
        align: "center",
        width: 100,
        slots: { customRender: "dateTime" },
      },
    ];

    onMounted(() => {
      getAttachFile();
    });

    watch(
      () => attachFileState.value.needReload,
      (currentValue, prevValue) => {
        // 첨부파일 등록/수정/삭제 후 테이블 목록 재조회
        if (currentValue) getAttachFile();
      }
    );

    watch(
      () => state.currentPage,
      () => {
        getAttachFile();
      }
    );

    const toggleModal = (name) => {
      state[name] = !state[name];
    };

    const handleSelect = (value) => {
      store.dispatch("attachFile/SELECT_ATTACH_FILE", value);
    };

    const CATEGORY_OPTIONS = [
      { label: t("Attach_Upload13"), value: 1 },
      { label: t("Attach_Upload15"), value: 2 },
      { label: t("Attach_Upload16"), value: 3 },
      { label: t("Attach_Upload17"), value: 4 },
    ];

    const EXAMTYPE_OPTIONS = [
      { label: t("Common_attach_title1"), value: 1 },
      { label: t("Common_Mok_txt"), value: 2 },
      { label: t("Common_attach_title6"), value: 3 },
      { label: t("TP_Edit_1_ExamType_Title4"), value: 4 },
    ];

    const PUBLIC_OPTIONS = [
      { label: t("Common_Public"), value: 1 },
      { label: t("Common_Private"), value: 0 },
    ];

    const filterItems = [
      {
        key: 'category',
        label: 'Attach_File1',
        model: 'selectedCategories',
        options: CATEGORY_OPTIONS,
      },
      {
        key: 'examType',
        label: 'Attach_File2',
        model: 'selectedExamTypes',
        options: EXAMTYPE_OPTIONS,
      },
      {
        key: 'public',
        label: 'Common_Public',
        model: 'selectedPublics',
        options: PUBLIC_OPTIONS,
      },
    ];

    const filterState = reactive({
      visible: false,
      selectedCategories: [],
      selectedExamTypes: [],
      selectedPublics: [],
    });

    // 페이지를 떠날 때 필터 상태 초기화
    onUnmounted(() => {
      store.dispatch('attachFile/CHANGE_FILTER', {});
    });

    // 실제 store에 반영된 필터 개수
    const filterCount = computed(() => {
      const categories = attachFileState.value.param?.filter?.attachCategory || [];
      const examTypes = attachFileState.value.param?.filter?.attachExamType || [];
      const publics = attachFileState.value.param?.filter?.isPublic || [];
      return (Array.isArray(categories) ? categories.length : 0) + (Array.isArray(examTypes) ? examTypes.length : 0) + (Array.isArray(publics) ? publics.length : 0);
    });

    const onFilterConfirm = () => {
      filterState.visible = false;
      store.dispatch('attachFile/CHANGE_FILTER', {
        ...attachFileState.value.param.filter,
        attachCategory: filterState.selectedCategories,
        attachExamType: filterState.selectedExamTypes,
        isPublic: filterState.selectedPublics,
      });
      getAttachFile();
    };

    const onFilterCancel = () => {
      filterState.visible = false;
      filterState.selectedCategories = attachFileState.value.param.filter?.attachCategory || [];
      filterState.selectedExamTypes = attachFileState.value.param.filter?.attachExamType || [];
      filterState.selectedPublics = attachFileState.value.param.filter?.isPublic || [];
    };

    const onFilterReset = () => {
      filterState.selectedCategories = [];
      filterState.selectedExamTypes = [];
      filterState.selectedPublics = [];
      filterState.visible = false;
      store.dispatch('attachFile/CHANGE_FILTER', {
        ...attachFileState.value.param.filter,
        attachCategory: [],
        attachExamType: [],
        isPublic: [],
      });
      getAttachFile();
    };

    const onSearch = (value) => {
      // 1페이지로 초기화
      state.currentPage = 1;
      getAttachFile();
    };

    const getAttachFile = async () => {
      state.loading = true;
      try {
        // filter 동적 생성
        const filter = {};
        const filterKeys = [
          { key: 'attachCategory', prop: 'attachCategory' },
          { key: 'attachExamType', prop: 'attachExamType' },
          { key: 'isPublic', prop: 'isPublic' },
        ];
        const paramFilter = attachFileState.value.param?.filter || {};
        filterKeys.forEach(({ key, prop }) => {
          const arr = paramFilter[prop];
          if (Array.isArray(arr) && arr.length > 0) {
            filter[key] = arr;
          }
        });
        if (state.searchText) filter.searchAll = state.searchText;
        const params = {
          filter,
          sort: {},
          offset: state.pagesize * (state.currentPage - 1),
          limit: state.pagesize,
        };

        const response = await axios.get(apiUrl + "AttachFile", { params });
        if (response && !response.data.error) {
          store.dispatch("attachFile/GET_ATTACH_FILE", response);
          state.tableData = response.data.list;
          state.pagination.current = state.currentPage;
          state.pagination.pageSize = state.pagesize;
          state.pagination.total = attachFileState.value.totalCount;
        }
      } catch (error) {
        console.log("get attach error", error);
      }
      state.loading = false;
    };

    // 페이지 변경 이벤트
    const handleTableChange = (pagination, filters, sorter) => {
      state.currentPage = pagination.current;
    };

    return {
      ...toRefs(state),
      btnDisable,
      handleTableChange,
      columns,
      toggleModal,
      handleSelect,
      getAttachFile,
      CATEGORY_OPTIONS,
      EXAMTYPE_OPTIONS,
      PUBLIC_OPTIONS,
      filterState,
      filterCount,
      filterItems,
      onFilterConfirm,
      onFilterCancel,
      onFilterReset,
      onSearch,
    };
  },
};
</script>

<style></style>